exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".catalog-page{position:absolute;height:100%;width:100%;top:0;left:0;opacity:0;display:none;pointer-events:none;transition:.3s;transform:translateZ(0)}.catalog-page.rendered{display:block}.catalog-page.visible{opacity:1;pointer-events:all}.catalog-page .content .summary-link-div{text-align:center;background:hsla(0,0%,100%,.5);padding:120px 90px}@media (max-width:680px){.catalog-page #products{padding:30px 10px}.catalog-page .button.big{font-size:1.3em;background-position:30px 17px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./app/catalog/pages/catalog.cmp.scss
// module id = 818
// module chunks = 1